/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/5-algorithms-to-sum-a-list-in-python",
  title: "5 algorithms to sum a list in Python",
  description: `Ever wondered what algorithm can sum a list/array the fastest in Python? Here's a surface level overview`
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Arsalan Ali",
      username: "arslanchaos",
      avatarUrl: "/avatars/arslanchaos.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/arslanchaos/status/1578112367187173376"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `/images/5-algorithms-to-sum-a-list-in-python-0.png`,
      children: [_jsx(_components.p, {
        children: "Ever wondered what algorithm can sum a list/array the fastest in Python? Here's a surface level overview"
      }), _jsx(_components.p, {
        children: "A Thread 🧵👇"
      }), _jsx(_components.p, {
        children: "#python3 #pythonic #pythonprogramming #programming #Algorithms #DataScience"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/5-algorithms-to-sum-a-list-in-python-1.png`,
      children: [_jsx(_components.p, {
        children: "First of we generated a random list of \"1000000\" numbers to feed all the algorithms."
      }), _jsx(_components.p, {
        children: "This very first algorithm uses the built-in sum method. Its the easiest one to implement."
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/5-algorithms-to-sum-a-list-in-python-2.png`,
      children: _jsx(_components.p, {
        children: "Second algorithm is just the traditional approach of creating a variable and\nthen using a for loop to add the sum into it."
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/5-algorithms-to-sum-a-list-in-python-3.png`,
      children: _jsx(_components.p, {
        children: "Third algorithm isn't basically anything new. As a matter of fact its written\nto slow down the process because sum method already iterates on a list/array.\nSo giving it a for loop should slow it down. It's just for experimental\npurposes."
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/5-algorithms-to-sum-a-list-in-python-4.png`,
      children: _jsx(_components.p, {
        children: "Fourth algorithm is based on reduce method. You need to specify some sort of\nfunction in it. You can use it without defining a function but for the sake of\nconsistency we've written it like this."
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/5-algorithms-to-sum-a-list-in-python-5.png`,
      children: _jsx(_components.p, {
        children: "Lastly we've used the Numpy Sum method in the fifth algorithm."
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/5-algorithms-to-sum-a-list-in-python-6.png`,
      children: _jsx(_components.p, {
        children: "As you can see from the results, Numpy Sum is the winner here. It beats the\nbuilt-in Sum method by quite a margin. Meanwhile our Sum Loop approach\nperforms the worst as expected. Reduce and Loop algorithms are almost similar\nin performance."
      })
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Hope you liked the surface-level review and it helped you to choose the better algorithm for your project next time. 😊🥳"
      }), _jsx(_components.p, {
        children: "If you want more content like this, make sure to follow me."
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
